import messages from "./messages.da";

export default {
	instant(key) {
		return typeof messages[key] !== "undefined" ? messages[key] : key;
	}
};
